import { render } from "./WindowResize.vue?vue&type=template&id=26fc4a39&lang=pug"
import script from "./WindowResize.vue?vue&type=script&lang=js"
export * from "./WindowResize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__